import { getDateWithYear, getTime } from '../shared/date';
import { formatPrice } from '../shared/currency';
import { getSubscriptionName } from './current-subscription-mapper';
import { getOrderName } from './order-mapper';

const getProductName = ({ order, subscription }) => {
    if (order) {
        return getOrderName(order.productId) || '';
    }

    if (subscription?.plan) {
        return getSubscriptionName(subscription.plan.name) || '';
    }

    return '';
};

const getProductHash = ({ order, subscription }) => {
    if (order) {
        return `order-${order.id}`;
    }

    if (subscription) {
        return `subscription-${subscription.id}`;
    }
};

const paymentMapper = {
    toDomain(paymentData) {
        return {
            amount: formatPrice(paymentData.amount, paymentData.currency),
            productName: getProductName(paymentData),
            productHash: getProductHash(paymentData),
            descriptor: paymentData.descriptor,
            method: paymentData.method,
            id: paymentData.id,
            date: getDateWithYear(paymentData.date),
            time: getTime(paymentData.date)
        };
    }
};

export {
    paymentMapper
};
